import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFbIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.096 16.69c0-7.542 0-11.313 2.343-13.656S8.554.69 16.096.69c7.543 0 11.314 0 13.657 2.343s2.343 6.114 2.343 13.657c0 7.542 0 11.313-2.343 13.657-2.343 2.343-6.114 2.343-13.657 2.343-7.542 0-11.314 0-13.657-2.344C.096 28.005.096 24.233.096 16.691Z"
      fill="url(#FbIcon_svg__a)"
    />
    <path
      d="M13.362 21.08v11.598h5.353V21.08h3.57l.713-4.46h-4.283v-3.123c0-1.25.446-2.23 2.41-2.23h2.05V7.16c-1.158-.178-2.408-.356-3.567-.356-3.659 0-6.246 2.23-6.246 6.244v3.57H9.347v4.46h4.015Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="FbIcon_svg__a"
        x1={16.096}
        y1={0.691}
        x2={16.096}
        y2={32.691}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18ADFE" />
        <stop offset={1} stopColor="#0164E1" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgFbIcon);
export default Memo;
